export default __webpack_public_path__ + "static/media/hr.7a57e2dd.svg";